import '../../../../../../util/styles/index.js';
import { useAdsStyles } from '../../../../../../util/styles/hooks/useAdsStyles.js';

var getSkeletonLoaderSize = function getSkeletonLoaderSize() {
  var defaultSize = '24';
  var defaultPadding = '2';
  return "calc((".concat(defaultSize, " - ").concat(defaultPadding, " * 2) / ").concat(defaultSize, " * 100%)");
};
var useIconLoadingContainer = function useIconLoadingContainer(props) {
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var skeletonLoaderSize = getSkeletonLoaderSize();
  return {
    style: mapAdsStyles({
      display: 'inline-flex'
    }),
    contentStyle: mapAdsStyles({
      display: 'none'
    }),
    skeletonContainerStyle: mapAdsStyles({
      display: 'inline-flex',
      width: props.iconSize,
      height: props.iconSize,
      justifyContent: 'center',
      alignItems: 'center'
    }),
    skeletonProps: {
      inline: true,
      width: skeletonLoaderSize,
      height: skeletonLoaderSize,
      borderRadius: '8'
    }
  };
};

export { useIconLoadingContainer };
//# sourceMappingURL=useIconLoadingContainer.js.map
